import { Action } from 'redux'
import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import { IResendConfirmationCodePayload } from '@app-store/slices/auth/resendActivationCode'
import { resendConfirmationCodeCognitoUser } from '@utils/authenticateService'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: IResendConfirmationCodePayload
}

const { onFailure, onSuccess, onRequest } = rootActions.auth.resendConfirmationCode

function* resendConfirmationCodeSaga({ payload }: TaskAction) {
    try {
        const response = yield resendConfirmationCodeCognitoUser({ username: payload.username })
        notification.success({
            message: 'Confirmation code has been sent to your email.'
        })
        yield put(onSuccess(response))
        yield payload.sagaCB?.onSuccess()
    } catch (e) {
        yield put(onFailure('Email is incorrect'))
    }
}

function* resendConfirmationCodeCodeSaga(): any {
    yield takeLatest<TaskAction>(onRequest, resendConfirmationCodeSaga)
}

export default resendConfirmationCodeCodeSaga
